import { createAction, props } from '@ngrx/store';
import { PayCustomerData, PaymentResponseData, CustomerVaultPayload } from '@core/models';
import { IResponseBadRequest, IResponseObjectSuccess } from '@core/interfaces';

export const PROCESS_PAYMENT = createAction('[Pay] Process Payment',props<{ amount: number,localId: string,diaLaboralId: string,isGuest: boolean, vaultedCardToken: string }>());
export const PROCESS_PAYMENT_SUCCESS = createAction('[Pay] Process Payment Success',props<{ response: IResponseObjectSuccess<PaymentResponseData> }>());
export const PROCESS_PAYMENT_FAILURE = createAction('[Pay] Process Payment Failure',props<{ error: IResponseBadRequest }>());

export const CREATE_CUSTOMER_LOGGED = createAction('[Pay] Create Customer Logged', props<{ customerData: CustomerVaultPayload }>());
export const CREATE_CUSTOMER_LOGGED_SUCCESS = createAction('[Pay] Create Customer Logged Success',  props<{  customer: PayCustomerData }>());
export const CREATE_CUSTOMER_LOGGED_FAILURE = createAction('[Pay] Create Customer Logged Failure', props<{ error: IResponseBadRequest }>());

export const PAY_UPDATE_LOADING = createAction('[Pay] Update Loading', props<{ loading: boolean }>());
  
export const CLEAR_CUSTOMER_DATA = createAction('[Pay] Clear Customer Data');
export const CLEAR_PAYMENT_DATA = createAction('[Pay] Clear Payment Data');
